import { useEditorRuntimeStore } from '../stores/useEditorRuntimeStore';

import { type GenericElement } from './element';

export type Coords = [number, number, number, number, number, number];

export const getSelectionAbsoluteCoords = (element: GenericElement) => {
  return [
    element.x,
    element.y,
    element.x + element.width,
    element.y + element.height,
    element.x + element.width / 2,
    element.y + element.height / 2,
  ];
};

export const sceneCoordsToViewportCoords = (pos: { x: number; y: number }) => {
  const { offsetLeft, offsetTop, scrollX, scrollY, zoom } =
    useEditorRuntimeStore.getState();
  return {
    x: (pos.x + scrollX) * zoom.value + offsetLeft,
    y: (pos.y + scrollY) * zoom.value + offsetTop,
  };
};
